import type React from "react";
import { forwardRef } from "react";
import { Badge } from "../Badge";

interface ColorBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  customColor?:
    | "green"
    | "red"
    | "blue"
    | "yellow"
    | "neutral"
    | "primary"
    | "orange"
    | "second_green";
}

export const ColorBadge = forwardRef(function ColorBadge(
  { customColor = "primary", ...props }: ColorBadgeProps,
  ref: React.Ref<HTMLSpanElement>,
) {
  return (
    <Badge variant="color" customColor={customColor} ref={ref} {...props} />
  );
});

ColorBadge.displayName = "ColorBadge";
